import { memo, useCallback, useEffect, useState } from "react";
import { useTranslate } from "helpers";
import { ContractSaleCardProps } from "./types";
import { TextField } from "ui/components/TextField/TextField";
import { NumberField } from "ui/components/TextField/NumberField";
import { Button } from "ui/components/Button/Button";
import { Modal } from "ui/components/Modal";
import ModalHeader from "ui/components/Modal/ModalHeader";
import ModalBody from "ui/components/Modal/ModalBody";
import ContractSaleEditCard from "./components/ContractSaleEditCard/ContractSaleEditCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchSettings, getSettings } from "services/api/settings/redux";
import { initialSettingEditForm } from "services/api/settings";
import { Setting } from "services/api/settings/types";



const ContractSaleCard: React.FC<ContractSaleCardProps> = () => {

    const { t } = useTranslate();
    const dispatch = useDispatch();
    const settingCopy = useSelector(getSettings);
    const [setting, setSetting] = useState<Setting>(initialSettingEditForm);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);

    useEffect(() => {
        setSetting(settingCopy);
    }, [settingCopy]);

    const handleEditClick = () => {
        setShowEditModal(true);
    };

    const handleEditSuccess = useCallback(() => {
        dispatch(fetchSettings() as any);
        setShowEditModal(false);
    }, []);

    return (
        <>
            {/* Prodajni ugovor */}
            <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
                <div className="flex flex-col flex-1 max-w-[300px]">
                    <p className="text-base font-bold text-slate-600 py-3">
                        2. {t("admin.setting.document.contract.sale.title")}
                    </p>
                    <p className="text-sm">
                        {t("admin.setting.document.contract.sale.description")}
                    </p>
                </div>
                <div className="flex justify-between items-start flex-1 px-3 my-3">
                    <div className="flex flex-col w-[400px]">
                        <div className="mb-3">
                            <TextField
                                type="text"
                                name="contractSaleFormatNumber"
                                label={t("admin.setting.document.contract.sale.contractnumber")}
                                placeholder={t("admin.setting.document.contract.sale.contractnumber")}
                                value={settingCopy.contractSaleFormatNumber}
                                disabled
                            ></TextField>
                        </div>
                        <div className="mb-3">
                            <ul className="common-list text-sm">
                                <li>{t("{YYYY} - godina kreiranja ugovora")}</li>
                                <li>{t("{YY} - zadnje dvije znamenke godine kreiranja ugovora")}</li>
                                <li>{t("{MM} - mjesec kreiranja ugovora")}</li>
                                <li>{t("{DD} - dan kreiranja ugovora")}</li>
                                <li>{t("{ID} - Identifikator ugovora u toj godini")}</li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <Button
                            variant="outlined"
                            children={t("admin.edit")}
                            onClick={handleEditClick}
                            startIcon="/media/icons/plus.svg"
                        />
                    </div>
                </div>
            </div>

            {/* Isporuka vozila */}
            <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
                <div className="flex flex-col flex-1 max-w-[300px]">
                    <p className="text-base font-bold text-slate-600 py-3">
                        2.1 Isporuka vozila
                    </p>
                    <p className="text-sm">
                        Postavke za isporuku vozila kupcu
                    </p>
                </div>
                <div className="flex flex-1 px-3 my-3">
                    <div className="flex flex-col w-[400px]">
                        <div className="mb-3">
                            <NumberField
                                name="contractSaleDeliveryTime"
                                label={t("admin.setting.document.contract.sale.deliverytime")}
                                value={settingCopy.contractSaleDeliveryTime}
                                decimals={0}
                                groupAppend="dana"
                                disabled
                            />
                        </div>
                        <div className="mb-3">
                            <TextField
                                type="text"
                                name="contractSalePlaceOfVehicleDelivery"
                                label={t("admin.setting.document.contract.sale.placeofvehicledelivery")}
                                value={settingCopy.contractSalePlaceOfVehicleDelivery}
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                <ModalHeader
                    title={t("admin.setting.document.contract.sale.edit.title")}
                    icon="/media/images/add-icon.svg"
                    onHide={() => setShowEditModal(false)}
                />
                <ModalBody>
                    {showEditModal && (
                        <ContractSaleEditCard
                            setting={setting}
                            setSetting={setSetting}
                            onSuccess={handleEditSuccess}
                            onClose={() => setShowEditModal(false)} />
                    )}
                </ModalBody>
            </Modal>

        </>
    );
};
export default memo(ContractSaleCard);